export class VehiclesPopoverController {
  constructor(parent, marker, info) {
    this._parent = parent;
    this._marker = marker;
    this._info = info;
    this._label = { bus: 'B', tram: 'TR', metro:'M', taxi:'FR' };

    // Popover View
    this._popoverView = new swim.PopoverView()
      .width(200)
      .height(115)
      .borderRadius(5)
      .padding(10)
      .backgroundColor(swim.Color.parse("#071013").alpha(0.9))
      .backdropFilter("blur(2px)");
    this._popoverView.setSource(this._marker);
    this._popoverView.hidePopover();

    // Box
    this._placard = this._popoverView.append('article')
      .className('placard');

    // Header
    this._header = this._placard.append('header');

    this._title = this._header.append('h2')
      .className('title');

    // List
    this._listwrap = this._placard.append('ul')
      .className('list-wrap')
      .color(swim.Color.black());

    this._li0 = this._listwrap.append('li');
    this._li0Text = this._li0.append('span');

    this._li1 = this._listwrap.append('li');
    this._li1Text = this._li1.append('span');

    // Content
    this._content = this._placard.append('div')
      .className('content');

    this._driverStatus = this._content.append('p')
      .className('driver-status')
      .color('#9c9d9f');

    this._date = this._content.append('p')
      .className('date')
      .color('#9c9d9f');

    this.update(this._info);
  }

  get view() {
    return this._popoverView;
  }

  update(info) {
    this._info = info;

    const status = info.get('status').stringValue();
    const color = this._parent.color;

    this._li0.backgroundColor(color);
    this._li0Text.text(status);

    this._placard.color(color);

    const id = info.get('plateNumber').stringValue('--');
    this._title.text(`#${id}`);

    const date = info.get('heading').stringValue();
    this._date.text(date);

    const labelType = info.get('type').stringValue();

    this._li1.backgroundColor(color);
    this._li1Text.text((info.get('type').stringValue() === 'Driving without a Tag')? 'NOT TAG' : 'TAG' );

    this._driverStatus.text(info.get('type').stringValue());
  }

}
